import { MenuItem } from './MenuItem';

export class MenuGroup {
  constructor(public title: string, public items: MenuItem[]) {}
}
